"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueOrEmpty = void 0;

var valueOrEmpty = function valueOrEmpty(data) {
  if (data || data === false || data === 0) {
    return data;
  }

  return '';
};

exports.valueOrEmpty = valueOrEmpty;


//////////////////
// WEBPACK FOOTER
// ./~/convert-array-to-csv/lib/helpers/value-or-empty.js
// module id = 82
// module chunks = 0